import { render, staticRenderFns } from "./MarqueeLogoSlider.vue?vue&type=template&id=19d0d6b6&"
import script from "./MarqueeLogoSlider.vue?vue&type=script&lang=js&"
export * from "./MarqueeLogoSlider.vue?vue&type=script&lang=js&"
import style0 from "./MarqueeLogoSlider.vue?vue&type=style&index=0&id=19d0d6b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports